import React, { useMemo } from 'react'
import ModulePanel from '../../../ui/ModulePanel/ModulePanel'
import DataTable from '../../../ui/DataTable/DataTable'
import Spinner from '../../../ui/Spinner/Spinner'
import { formatDateAsDayMontYearHHMM } from '../../../utils/date/dateFormat'
import PromoTypeBadge from './PromoTypeBadge'
import ActiveStatusBadge from '../../../ui/ActiveStatusBadge/ActiveStatusBadge'
import './PromosTable.sass'

const renderTimestamp = (value) => {
  if (!value?.seconds) {
    return '—'
  }

  return formatDateAsDayMontYearHHMM(value)
}

function PromosTable({ schedules = [], isLoading }) {
  const columns = useMemo(
    () => [
      {
        field: 'createdAtSort',
        headerName: 'Створено sort',
        type: 'number',
      },
      {
        field: 'statusSort',
        headerName: 'Стан sort',
        type: 'number',
      },
      {
        field: 'startedAtSort',
        headerName: 'Початок sort',
      },
      {
        field: 'created',
        headerClassName: 'TableHeadCol',
        headerName: 'Створено',
        width: 170,
        renderCell: (params) => renderTimestamp(params.row.created),
      },
      {
        field: 'promoTypeLabel',
        headerClassName: 'TableHeadCol',
        headerName: 'Тип',
        width: 160,
        renderCell: (params) => (
          <PromoTypeBadge variant={params.row.promoTypeVariant} label={params.row.promoTypeLabel} />
        ),
      },
      {
        field: 'cashboxScheduleName',
        headerClassName: 'TableHeadCol',
        headerName: 'Назва промо / акції',
        minWidth: 220,
        flex: 1,
        cellClassName: 'MarketingPromos-TitleCellCol',
        renderCell: (params) => (
          <span className="MarketingPromos-TitleCell">{params.row.cashboxScheduleName || '—'}</span>
        ),
      },
      {
        field: 'status',
        headerClassName: 'TableHeadCol',
        headerName: 'Стан',
        width: 110,
        renderCell: (params) => <ActiveStatusBadge variant={params.row.status} />,
      },
      {
        field: 'dateRangeLabel',
        headerClassName: 'TableHeadCol',
        headerName: 'Період',
        width: 190,
        renderCell: (params) => (
          <span className="MarketingPromos-PeriodCell">{params.row.dateRangeLabel || '—'}</span>
        ),
      },
      {
        field: 'brandLabel',
        headerClassName: 'TableHeadCol',
        headerName: 'Бренд',
        width: 140,
        cellClassName: 'MarketingPromos-BrandCellCol',
        renderCell: (params) => (
          <span className="MarketingPromos-BrandCell" title={params.row.brandLabel || undefined}>
            {params.row.brandLabel || '—'}
          </span>
        ),
      },
      {
        field: 'productsLabel',
        headerClassName: 'TableHeadCol',
        headerName: 'Товарів',
        width: 90,
        renderCell: (params) => params.row.productsLabel || '—',
      },
      {
        field: 'updated',
        headerClassName: 'TableHeadCol',
        headerName: 'Оновлено',
        width: 170,
        renderCell: (params) => renderTimestamp(params.row.updated),
      },
    ],
    []
  )

  return (
    <ModulePanel title="Акції дистриб’юторів">
      {isLoading ? (
        <Spinner type="module" />
      ) : (
        <div className="MarketingPromos-Table">
          <DataTable
            initialState={{
              sorting: {
                sortModel: [{ field: 'createdAtSort', sort: 'desc' }],
              },
              columns: {
                columnVisibilityModel: {
                  createdAtSort: false,
                  statusSort: false,
                  startedAtSort: false,
                },
              },
            }}
            table={{
              rows: schedules,
              columns,
              autoHeight: true,
            }}
          />
        </div>
      )}
    </ModulePanel>
  )
}

export default PromosTable
